/**
 * valus for the enums are the `message` property for the incoming submission
 * error
 */

export enum SUBMISSION_ERR {
  /*** SIGN UP ***/

  // thrive `get_auth_config` - either the group code or domain key is not found
  COMPANY_HINT = 'PreSignUp failed with error COMPANY_INVALID.',

  // Cognito sign-up error - user email registered already
  EXISTING_USER = 'An account with the given email already exists.',
  // prod env seems to have a different message for a UsernameExistsException code
  EXISTING_USER_PROD = 'User already exists',
  // we now account for multiple user pools
  EXISTING_USER_IN_USER_POOL = 'PreSignUp failed with error EMAIL_EXISTS.',

  /*** SIGN IN ***/

  // Cognito sign-in error
  NONEXISTENT_USER = 'User does not exist.',
  INCORRECT_USER_PWORD = 'Incorrect username or password.',
  CLIENT_NOT_FOUND = 'Client not found',

  /*** FORGOT YOUR PASSWORD ***/

  PASSWORD_RESET_VERIFICATION_CODE_INVALID = 'Invalid verification code provided, please try again.',
  // https://github.com/aws-amplify/aws-sdk-ios/issues/384
  INVALID_USER_FORGOT_PASSWORD = 'Username/client id combination not found.',
  // password reset forms maxed
  MAX_PASSWORD_RESET_ATTEMPTS = 'Attempt limit exceeded, please try after some time.',
  // password reset verification code expired
  PASSWORD_RESET_VERIFICATION_CODE_EXPIRED = 'Invalid code provided, please request a code again.',

  /*** USED BY MULTIPLE FORMS ***/

  // sign up sign in attempts maxed for a certain amount of time
  MAX_SIGN_UP_SIGN_IN_ATTEMPTS = 'Password attempts exceeded',
  // email domain not whitelisted
  EMAIL_DOMAIN_INVALID = 'Invalid email domain.',
  GENERAL = 'SUBMISSION_ERROR',
}
